import { render } from "./LogicSelect.vue?vue&type=template&id=332a8889"
import script from "./LogicSelect.vue?vue&type=script&lang=js"
export * from "./LogicSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__